import { useEffect } from 'react';

import { config } from '@app/config';

const rudderStackScriptInnerHtml = (
  writeKey: string,
  dataPlaneUrl: string,
) => `!function(){"use strict";window.RudderSnippetVersion="3.0.60";var e="rudderanalytics";window[e]||(window[e]=[])
  ;var rudderanalytics=window[e];if(Array.isArray(rudderanalytics)){
  if(true===rudderanalytics.snippetExecuted&&window.console&&console.error){
  console.error("RudderStack JavaScript SDK snippet included more than once.")}else{rudderanalytics.snippetExecuted=true,
  window.rudderAnalyticsBuildType="legacy";var sdkBaseUrl="https://cdn.rudderlabs.com";var sdkVersion="v3"
  ;var sdkFileName="rsa.min.js";var scriptLoadingMode="async"
  ;var r=["setDefaultInstanceKey","load","ready","page","track","identify","alias","group","reset","setAnonymousId","startSession","endSession","consent"]
  ;for(var n=0;n<r.length;n++){var t=r[n];rudderanalytics[t]=function(r){return function(){var n
  ;Array.isArray(window[e])?rudderanalytics.push([r].concat(Array.prototype.slice.call(arguments))):null===(n=window[e][r])||void 0===n||n.apply(window[e],arguments)
  }}(t)}try{
  new Function('class Test{field=()=>{};test({prop=[]}={}){return prop?(prop?.property??[...prop]):import("");}}'),
  window.rudderAnalyticsBuildType="modern"}catch(i){}var d=document.head||document.getElementsByTagName("head")[0]
  ;var o=document.body||document.getElementsByTagName("body")[0];window.rudderAnalyticsAddScript=function(e,r,n){
  var t=document.createElement("script");t.src=e,t.setAttribute("data-loader","RS_JS_SDK"),r&&n&&t.setAttribute(r,n),
  "async"===scriptLoadingMode?t.async=true:"defer"===scriptLoadingMode&&(t.defer=true),
  d?d.insertBefore(t,d.firstChild):o.insertBefore(t,o.firstChild)},window.rudderAnalyticsMount=function(){!function(){
  if("undefined"==typeof globalThis){var e;var r=function getGlobal(){
  return"undefined"!=typeof self?self:"undefined"!=typeof window?window:null}();r&&Object.defineProperty(r,"globalThis",{
  value:r,configurable:true})}
  }(),window.rudderAnalyticsAddScript("".concat(sdkBaseUrl,"/").concat(sdkVersion,"/").concat(window.rudderAnalyticsBuildType,"/").concat(sdkFileName),"data-rsa-write-key","${writeKey}")
  },
  "undefined"==typeof Promise||"undefined"==typeof globalThis?window.rudderAnalyticsAddScript("https://polyfill-fastly.io/v3/polyfill.min.js?version=3.111.0&features=Symbol%2CPromise&callback=rudderAnalyticsMount"):window.rudderAnalyticsMount()
  ;var loadOptions={};rudderanalytics.load("${writeKey}","${dataPlaneUrl}",loadOptions)}}}();`;

declare global {
  interface Window {
    rudderanalytics?: {
      load: (writeKey: string, dataPlaneUrl: string) => void;
      page: (name?: string, properties?: object) => void;
      track: (event: string, properties?: object) => void;
      identify: (userId: string, traits?: object) => void;
      reset: () => void;
    };
  }
}

export const RudderStackScript = () => {
  useEffect(() => {
    if (config.deploymentEnv !== 'production' && config.deploymentEnv !== 'qa') {
      return;
    }

    const rudderWriteKey = config.analytics.rudderstack.writeKey;
    const rudderDataPlaneUrl = config.analytics.rudderstack.dataPlaneUrl;

    if (!rudderWriteKey || !rudderDataPlaneUrl) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = rudderStackScriptInnerHtml(rudderWriteKey, rudderDataPlaneUrl);
    document.head.appendChild(script);
  }, []);

  return null;
};
